import { render, staticRenderFns } from "./EditTeam.vue?vue&type=template&id=38cd6544&scoped=true&"
import script from "./EditTeam.vue?vue&type=script&lang=js&"
export * from "./EditTeam.vue?vue&type=script&lang=js&"
import style0 from "./EditTeam.vue?vue&type=style&index=0&id=38cd6544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cd6544",
  null
  
)

export default component.exports